import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/Auth/AuthContext";
import useCompanySettings from "../hooks/useSettings/companySettings";
import ClassicLayout from "./ClassicLayout";
import ModernLayout from "./ModernLayout";
import BackdropLoading from "../components/BackdropLoading";

/**
 * LoggedInLayout - Seletor de Layout
 * 
 * Este componente verifica a configuração "layoutType" da empresa
 * e carrega o layout apropriado:
 * - "modern" = Layout moderno (navbar horizontal)
 * - "classic" = Layout clássico (menu lateral)
 * 
 * A configuração pode ser alterada em:
 * Configurações → Aparência → Tipo de Layout
 */
const LoggedInLayout = (props) => {
  const { user, isAuth, loading: authLoading } = useContext(AuthContext);
  const { get: getSetting } = useCompanySettings();
  const [layoutType, setLayoutType] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLayoutType = async () => {
      try {
        if (authLoading) {
          return;
        }

        if (!isAuth) {
          setLayoutType(null);
          setLoading(false);
          return;
        }

        if (user?.companyId) {
          const setting = await getSetting({
            column: "layoutType"
          });
          
          // Se encontrou a configuração, usa ela
          if (setting && setting.layoutType) {
            setLayoutType(setting.layoutType);
          } else {
            // Fallback para modern se não encontrar
            setLayoutType("modern");
          }
        } else {
          // Sem companyId, usa modern
          setLayoutType("modern");
        }
      } catch (error) {
        console.log("Erro ao buscar layoutType, usando modern:", error);
        // Em caso de erro, usa modern
        setLayoutType("modern");
      } finally {
        setLoading(false);
      }
    };

    // Pequeno delay para garantir que o contexto está carregado
    const timer = setTimeout(() => {
      fetchLayoutType();
    }, 100);

    return () => clearTimeout(timer);
  }, [authLoading, isAuth, user?.companyId, getSetting]);

  // Mostra loading enquanto busca a configuração
  if (authLoading) {
    return <BackdropLoading />;
  }

  if (!isAuth) {
    return <>{props.children}</>;
  }

  if (loading || !layoutType) {
    return <BackdropLoading />;
  }

  // Renderiza o layout apropriado
  if (layoutType === "modern") {
    return <ModernLayout {...props} />;
  }

  return <ClassicLayout {...props} />;
};

export default LoggedInLayout;
